import { PickingListRecordRowShape } from '../../api/api_data_types'

export default function pickingListExportTitle(row: PickingListRecordRowShape): string | undefined {
  if (row.export_status === 'export_error') return row.export_error || undefined
  if (row.export_status === 'exporting') return 'Export in progress'
  return undefined
}
